import { JSON_KEYWORD_INFO } from "../define/json";
import { jobboxApi } from "../api/jobbox";

export const getJsonKeywords = () => {
  return JSON_KEYWORD_INFO;
};

export const getJobboxJson = async (keyword: string, site?: string) => {
  if (!site) {
    const siteTmp = getJobboxSiteString();
    if (siteTmp === null) {
      return false;
    }
    site = siteTmp;
  }

  const response = await jobboxApi.get(keyword, site);
  
  if (response.ok) {
    return await response.json();
  } else {
    throw new Error(`Failed to fetch jobbox json: ${response.statusText}`);
  }
}

export const getJobboxSiteString = (host?: string) => {
  if (!host) {
    host = location.hostname;
  }
  
  if (host.includes("select.mamastar.jp")) {
    return "mamastar-select";
  }
  else if (host.includes("mamastar.jp")) {
    return "mamastar-bbs";
  }
  else if (host.includes("yogajournal.jp")) {
    return "yogajournal";
  }
  else if (host.includes("saita-puls.com")) {
    return "saita-puls";
  }
  else if (host.includes("4meee.com")) {
    return "4meee";
  }
  else if (host.includes("4yuuu.com")) {
    return "4yuuu";
  }
  return null;
}